export const FORMULARIO_ROUTES: { [key: string]: string } = {
  ATIVIDADES: 'painel/atividades-online',
  PLANOAULA: 'painel/planejamento-de-aula',
  FREQUENCIA: 'painel/frequencia',
  FREQUENCIARECUPERACAO: 'painel/frequencia-recuperacao',
  CONTEUDO: 'painel/cont',
  NOTAS: 'painel/notas',
  HABILIDADES: 'painel/habilidades',
  OBSTURMA: 'painel/observacao',
  MURALTURMA: 'painel/mural-da-turma',
  PARECERDESCRITIVO: 'painel/parecer-descritivo',
  'ACOMPANHAMENTO AEE': 'painel/acompanhamento-aee-aluno',
};
